<template>
  <div class="career-stats__with-period">
    <h1 v-if="!accountSummaryFlow">{{ $t('Account.CareerStats') }}</h1>
    <div class="loading" v-if="loader">
      <dots-loader></dots-loader>
    </div>
    <div v-if="!loader" class="caca">
      <div v-if="brandTemplate !== 'generic_2'" :class="['career-stats__date-filter datefilter', { 'active': filterExpanded}]" @click="toggleFilter()">
        <div>
          <div class="date_range_text">{{ $t('Account.TransactionHistory.History') }}</div>
          <div class="date_range">{{dateFrom | moment(dateFormats.longDate)}} {{ $t('Account.TransactionHistory.History.To') }} {{dateTo | moment(dateFormats.longDate)}}</div>
        </div>
        <div class="filter">{{ $t('Account.TransactionHistory.Filter') }}</div>
      </div>

      <!-- Generic template -->
      <div v-if="brandTemplate === 'generic_2'" class="daterange_holder">
        <div class="btn-date" :class="{ 'active': calendarDateFrom }" @click="showCalendarDateFrom()">
            <div class="headhint">{{ $t('Account.TransactionHistory.History.DateFrom') }}</div>
            <div class="date_from_to">{{ dateFrom | moment(dateFormats.longDateWitDayName) }}</div>
          </div>
        <div class="btn-date" :class="{ 'active': calendarDateTo }" @click="showCalendarDateTo()">
            <div class="headhint">{{ $t('Account.TransactionHistory.History.To') }}</div>
            <div class="date_from_to">{{ dateTo | moment(dateFormats.longDateWitDayName) }}</div>
          </div>
      </div>
      <!-- Generic template end -->
      <div class="calendar-container" v-if="filterExpanded">
        <div v-if="brandTemplate !== 'generic_2'" class="calendar-buttons">
          <div class="btn-date" :class="{ 'active': calendarDateFrom }" @click="showCalendarDateFrom()">
            <div class="headhint">{{ $t('Account.TransactionHistory.History.DateFrom') }}</div>
            <div class="date_from_to">{{ dateFrom | moment(dateFormats.longDateWitDayName) }}</div>
          </div>
          <div class="btn-date" :class="{ 'active': calendarDateTo }" @click="showCalendarDateTo()">
            <div class="headhint">{{ $t('Account.TransactionHistory.History.To') }}</div>
            <div class="date_from_to">{{ dateTo | moment(dateFormats.longDateWitDayName) }}</div>
          </div>
        </div>
        <div class="calendar">
          <v-date-picker v-if="calendarDateFrom" v-model="dateFromFormated" :max="dateToFormated" :full-width="true" :no-title="true"></v-date-picker>
          <v-date-picker v-if="calendarDateTo" v-model="dateToFormated" :min="dateFromFormated" :max="dateMaxFormated" :full-width="true" :no-title="true"></v-date-picker>
        </div>
        <div class="apply">
          <v-btn x-large @click.stop="fetchStats()"><span>{{ $t('Account.TransactionHistory.Apply') }}</span></v-btn>
        </div>
      </div>
      <div class="page-content account">
        <div class="career-stats ctsform">
          
          <div class="car-sts-cointainer">
            <div class="car-sts-info acc_infomsg_default">{{ $t('Account.CareerStatsWithPeriod.Info') }}</div>
            <div class="cld total">
              <span class="type">{{ $t('Account.CareerStats.Total') }}</span>
              <span class="amount">{{ total | currency }}</span>
            </div>
            <div class="cld winnings">
              <span class="type">{{ $t('Account.CareerStats.Winnings') }}</span>
              <span class="amount">{{ winnings | currency}}</span>
            </div>
            <div class="cld bets">
              <span class="type">{{ $t('Account.CareerStats.Bets') }}</span>
              <span class="amount">{{ bets | currency}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import lib from '@/library'
  import dotsLoader from '@/components/common/DotsLoader'
  import Branding from '@/components/mixins/Branding'
  import moment from 'moment'
  import config from '@/config'

  export default {
    components: {
      dotsLoader
    },
    mixins: [
      Branding
    ],
    data () {
      return {
        filterExpanded: false,
        dateFrom: new Date(new Date() - (7 * 24 * 60 * 60 * 1000)),
        dateTo: new Date(),
        calendarDateFrom: true,
        calendarDateTo: false,
        loader: false,
        careerStats: {
          Bets: null,
          Winnings: null,
          Total: null
        }
      }
    },
    computed: {
      accountSummaryFlow () {
        return window.ctsautoconf.ACCOUNT_SUMMARY_FLOW || false
      },
      dateMaxFormated () {
        return moment(new Date()).format(this.dateFormats.isoDate)
      },
      dateFromFormated: {
        get () {
          return moment(this.dateFrom).format(this.dateFormats.isoDate)
        },
        set (value) {
          this.dateFrom = moment(value, 'YYYY-MM-DD').toDate() // creates date in locale timezone and resolves -GTM timezone offsets
        }
      },
      dateToFormated: {
        get () {
          return moment(this.dateTo).format(this.dateFormats.isoDate)
        },
        set (value) {
          this.dateTo = moment(value, 'YYYY-MM-DD').toDate() // creates date in locale timezone and resolves -GTM timezone offsets
        }
      },
      dateFormats () {
        return config.app.dateFormats
      },
      bets () {
        return this.careerStats && this.careerStats.Bets
      },
      winnings () {
        return (this.careerStats && this.careerStats.Winnings) || (this.careerStats && this.careerStats.Winings)
      },
      total () {
        return this.careerStats && this.careerStats.Total
      }
    },
    methods: {
      toggleFilter () {
        this.filterExpanded = !this.filterExpanded
      },
      showCalendarDateFrom () {
        if (this.brandTemplate === 'generic_2') {
          this.filterExpanded = true
        }
        this.calendarDateFrom = true
        this.calendarDateTo = false
      },
      showCalendarDateTo () {
        if (this.brandTemplate === 'generic_2') {
          this.filterExpanded = true
        }
        this.calendarDateFrom = false
        this.calendarDateTo = true
      },
      async fetchStats () {
        this.loader = true
        try {
          let dateFrom2 = moment(this.dateFrom)
          let dateTo2 = moment(this.dateTo)
          if (dateFrom2 && dateTo2) {
            dateFrom2.hour(0)
            dateFrom2.minute(0)
            dateFrom2.second(1)
            dateTo2.hour(23)
            dateTo2.minute(59)
            dateTo2.second(59)
          }

          let response = await lib.rpcService.callBroker('iwservice', 'getaccountperiodstats', {
            'dateFrom': dateFrom2.format(config.app.dateFormats.iso8601),
            'dateTo': dateTo2.format(config.app.dateFormats.iso8601)
          })
          if (response && response.result) {
            this.careerStats = response.result
            this.filterExpanded = false
          }
        } catch (error) {
          console.log(`CareerStatsWithPeriod.fetchStats | ERROR | ${error && error.message}`)
        } finally {
          this.loader = false
        }
      }
    },
    mounted () {
      this.fetchStats()
    }
  }
</script>

<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'

.loading
  text-align center
.caca
  user-select none
  text-size-adjust none
  .career-stats__date-filter
    display flex
    border solid 1px #efefef
    border-radius 5px
    padding 5px
    justify-content space-between
    align-items center
    cursor pointer
    .filter
      text-transform uppercase
      font-family: "Open Sans Bold"
      color #000
    &.active
      border-bottom none
      border-bottom-left-radius 0
      border-bottom-right-radius 0
  .calendar-container
    border-left solid 1px #efefef
    border-right solid 1px #efefef
    border-bottom solid 1px #efefef
    border-bottom-left-radius 5px
    border-bottom-right-radius 5px
    padding 5px
    .calendar-buttons
      display flex
      justify-content center
      .btn-date
        // flex 0.2
        margin 5px
        border 1px solid #efefef
        padding 5px
        border-radius 5px
        cursor pointer
        @media mobile-big-and-below
          flex 1
        &.active
          border 1px solid #2a77aa
        .headhint
          color #2a77aa
          text-transform uppercase
          font-family: "Open Sans Bold"
          font-size 10px
        .date_from_to
          font-family: "Open Sans Bold"
    .apply
      text-align center
  .cld
    display flex
    padding 8px 2px
    &:nth-child(odd)
      background #f2f2f2
    &.total
      font-weight bold
      font-size 16px
    .type
      flex-grow 30
.page-content.account
  .career-stats.ctsform
    width 100%
    .car-sts-cointainer
      margin 5px
      border 1px solid #dbdce0
      padding 10px
      border-radius 0px
      cursor default
      .car-sts-info
        margin 5px 0
        display flex
      .caca
        margin-top 3px
        
</style>



// WEBPACK FOOTER //
// src/components/account/CareerStatsWithPeriod.vue